import styled from "styled-components";

export const FooterStyled = styled.footer`
    position: relative;
    z-index: 8;

    max-width: 100%;
    margin-top: auto;
`;
